import { nodeListToArray } from '../helpers/nodeListToArray';
import { FixedHeaders } from './navHeights';

export function globalAlert() {
    const dismissButtons = nodeListToArray(document.querySelectorAll("[data-alert-dismiss-id]")) as HTMLButtonElement[];
    const alerts = nodeListToArray(document.querySelectorAll("[data-alert-id]")) as HTMLElement[];
    dismissButtons.forEach(dismissButton => {
        dismissButton.addEventListener("click", () => {
            const matchingAlerts = alerts.filter((element) => {
                return element.getAttribute("data-alert-id") == dismissButton.getAttribute("data-alert-dismiss-id");
            });
            matchingAlerts.forEach(alert => {
                alert.setAttribute("aria-hidden", "true");
            });
            var cookie = getCookie("notificationsdismissed");
            if (cookie) {
                setCookie("notificationsdismissed", cookie + "," + dismissButton.getAttribute("data-alert-dismiss-id"), 7);
            }
            else {
                setCookie("notificationsdismissed", dismissButton.getAttribute("data-alert-dismiss-id"), 7);
            }
            FixedHeaders.setHeightProperties();
        });
    });
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
}



